import { WishlistEffects } from './wishlist.effect'

export const effects = [
  WishlistEffects
]

export * from './wishlist.effect'
